<template>
  <div
    class="waggon-info color-3 t-rounded t-shadow"
    >
    <div class="waggon-info-header">
      <slot name="header" :waggon="waggon"/>
    </div>
    <div class="waggon-info-body">
      <slot name="body"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['waggon'],
  }
</script>
<style>
  .waggon-info {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 2px;
  }
  .waggon-info-header {
    display: flex;
    width: 100%;
  }
  .waggon-info-body {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
</style>
